import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '@repo/ui/components/ui/button';
import { SIGN_IN } from '@/lib/constants/routes';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-4xl font-bold mb-4">404</h1>
      <p className="text-muted-foreground mb-8">Page not found</p>
      <Button onClick={() => navigate({ to: SIGN_IN })}>
        {t('commons.back')}
      </Button>
    </div>
  );
}
